/**
 *
 * @param {object[]} secuencia
 * @param {string} accion
 * @returns {object[]}
 */
export const secuenciaReducer = (secuencia, accion) => {
    if (accion.tipo == "agregar") {
        return [...secuencia, accion.valor];
    } else if (accion.tipo == "llenar") {
        return accion.valor;
    } else if (accion.tipo == "eliminar") {
        return secuencia.filter((_, indice) => indice != accion.valor);
    }

    return secuencia;
};
